'use client';

import { Flex, Typography } from '@components/Freddy';
import { InsuranceExplanationIcon } from '@coolblue-development/next-insurance/client';
import type { InsuranceProduct as InsuranceProductType } from '@features/product/typings';
import { InsuranceProvider } from '@features/product-page/typings/insurance';
import useTestId from '@hooks/useTestId';
import { ComponentProps } from 'react';

import InsuranceProductPrice from './InsuranceProductPrice';
import StyledListItem from './StyledListItem';

type Props = {
  insuranceProduct: InsuranceProductType;
  primaryProductId: number;
  provider: InsuranceProvider;
};

export default function InsuranceProduct({ insuranceProduct, primaryProductId, provider }: Props) {
  const testId = useTestId('insurance-product');

  const getExplanationIconProps = () => ({
    productId: primaryProductId,
    title: insuranceProduct.title,
    trackingSubFeature: 'product_page' as ComponentProps<
      typeof InsuranceExplanationIcon
    >['trackingSubFeature']
  });

  return (
    <StyledListItem>
      <Flex ml={100} direction='column' sx={{ width: '100%' }} {...testId}>
        <Flex
          inline
          direction='row'
          alignItems='center'
          justifyContent={{ xs: 'space-between', md: 'flex-start' }}
        >
          <Typography mb={0}>{insuranceProduct.title} </Typography>
          {provider === InsuranceProvider.CoverGenius && (
            <InsuranceExplanationIcon
              {...getExplanationIconProps()}
              insuranceQuoteId={insuranceProduct.id}
              provider={InsuranceProvider.CoverGenius}
            />
          )}
          {provider === InsuranceProvider.ERGO && (
            <InsuranceExplanationIcon
              {...getExplanationIconProps()}
              insuranceProductId={insuranceProduct.id}
              provider={InsuranceProvider.ERGO}
            />
          )}
        </Flex>

        <InsuranceProductPrice product={insuranceProduct} size='small' />
      </Flex>
    </StyledListItem>
  );
}
